module.exports = __webpack_public_path__ + "static/media/ellipsis-v.de75d243.svg";